import axios from 'axios'
import { endpoints } from './endpoints';

const adminEndpoints = endpoints.admin;

export function hasPermission() {
  return axios.get(adminEndpoints.hasPermission())
}

export function getUsers() {
  return axios.get(adminEndpoints.getUsers())
}

export function updateUserType(data) {
  return axios.patch(adminEndpoints.updateUserType(), data)
}

export function getOTPSentHistory() {
  return axios.get(adminEndpoints.getOTPSentHistory())
}

export function getProject(projectId: string) {
  return axios.get(adminEndpoints.getProject(projectId))
}

export function getProjects() {
  return axios.get(adminEndpoints.getProjects())
}

export function getChatMessages(startDt: string, endDt: string, timezoneOffset: number, origin?: string, modelTypes?: string[], selectedUserTypes?: string[], onlyCategories?: boolean) {
  return axios.post(adminEndpoints.getChatMessages(), {start_dt:startDt, end_dt:endDt, timezone_offset:timezoneOffset, origin:origin, model_types:modelTypes, user_types:selectedUserTypes, only_categories:onlyCategories})
}

export function getChatMessageProjects(startDt: string, endDt: string, timezoneOffset: number) {
  return axios.post(adminEndpoints.getChatMessageProjects(), {start_dt:startDt, end_dt:endDt, timezone_offset:timezoneOffset})
}

export function getChatMessageModelIDs(startDt: string, endDt: string, timezoneOffset: number) {
  return axios.post(adminEndpoints.getChatMessageModelIDs(), {start_dt:startDt, end_dt:endDt, timezone_offset:timezoneOffset})
}

export function getContentInterventions(){
  return axios.get(adminEndpoints.getContentInterventions())
}

export function addContentInterventions(data: any){
  return axios.post(adminEndpoints.addContentInterventions(), data)
}

export function deleteContentIntervention(contentInterventionId: number){
  return axios.delete(adminEndpoints.deleteContentIntervention(contentInterventionId))
}

export function deleteAllContentInterventions(){
  return axios.delete(adminEndpoints.deleteAllContentInterventions())
}

export function getContentBlocklists(type: string){
  return axios.get(adminEndpoints.getContentBlocklists(type))
}

export function addContentBlocklist(type: string, data: any){
  return axios.post(adminEndpoints.addContentBlocklist(type), data)
}

export function deleteContentBlocklist(type: string, contentBlocklistId: number){
  return axios.delete(adminEndpoints.deleteContentBlocklist(type, contentBlocklistId))
}

export function deleteAllContentBlocklists(type: string){
  return axios.delete(adminEndpoints.deleteAllContentBlocklists(type))
}

export function getContentIslamic(){
  return axios.get(adminEndpoints.getContentIslamic())
}

export function addContentIslamic(data: any){
  return axios.post(adminEndpoints.addContentIslamic(), data)
}

export function deleteContentIslamic(contentIslamicId: number){
  return axios.delete(adminEndpoints.deleteContentIslamic(contentIslamicId))
}

export function deleteAllContentIslamic(){
  return axios.delete(adminEndpoints.deleteAllContentIslamic())
}

export function getPromptClassifications(startDate: string, endDate: string, timezoneOffset: number){
  return axios.post(adminEndpoints.getPromptClassifications(), {start_dt:startDate, end_dt:endDate, timezone_offset:timezoneOffset})
}

export function getPromptInterventionSimilarities(startDate: string, endDate: string, timezoneOffset: number){
  return axios.post(adminEndpoints.getPromptInterventionSimilarities(), {start_dt:startDate, end_dt:endDate, timezone_offset:timezoneOffset})
}

export function getFilteredContent(startDate: string, endDate: string, timezoneOffset: number){
  return axios.post(adminEndpoints.getFilteredContent(), {start_dt:startDate, end_dt:endDate, timezone_offset:timezoneOffset})
}

export function getContentSafetyScores(startDate: string, endDate: string, timezoneOffset: number){
  return axios.post(adminEndpoints.getContentSafetyScores(), {start_dt:startDate, end_dt:endDate, timezone_offset:timezoneOffset})
}